<template>
    <h1>{{ $t("shared.errors.ui.unhandled-error-happened") }} : {{ errorMessage }}</h1>    

    <h5>{{errorAction}}</h5>

    <button @click="copyToClipboard" v-if="canUseClipboard">{{ $t("shared.ui.buttons.copyToClipboard") }}</button>
    <button @click="selectAllDetails">{{ $t("shared.ui.buttons.selectAll") }}</button>
    <pre style="word-wrap: anywhere; white-space: pre-wrap;" ref="preDetails">
{{ errorDetails }}
    </pre>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import { AppError } from "../../services/errorHandling";
import { modalDefinedEmits, useModalBuilder} from "../../helpers/modal-building-helper";
import { toastSuccess } from "@/.shared/services/notification-service";
import { useIntl} from "@services/i18n";



const props = defineProps<{
    error: AppError
}>();

defineEmits([...modalDefinedEmits])

const canUseClipboard = navigator.clipboard !== undefined;
const errorMessage = computed(() => props.error.message);
const errorDetails = computed(() => props.error.toJson());
const errorAction = computed(() => props.error.userAction);
const preDetails = ref<HTMLPreElement | null>(null);
const intl = useIntl();

onMounted(async () => {
    const builder = useModalBuilder();
    builder.setContext(getCurrentInstance()!);

    const cerrarButton = builder.standardButtons.addOk();    
    cerrarButton.update((btn: any) => {
        btn.onClick = () => builder.close();
        btn.text = intl.i18n.t("shared.ui.buttons.close");
    });
})

function selectAllDetails() {
    window.getSelection()?.selectAllChildren(preDetails.value!);
}

async function copyToClipboard() {
    await navigator.clipboard.writeText(errorDetails.value);
    await toastSuccess("Detalles de error copiados al portapapeles");
}

</script>

<style scoped>

</style>